import React from "react";
import Loader from "../Loader/Loader";

const DeleteButton = ({
  text,
  customClass,
  disabled,
  onClick,
  submit = "button",
  isLoading,
}) => {
  return (
    <>
      <button
        type={submit}
        // disabled={disabled}
        onClick={onClick}
        className={`w-fit relative text-white bg-red-500 hover:bg-red-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center h-fit hover:shadow-md ${customClass}`}
      >
        {isLoading && (
          <div className="absolute inset-0 flex justify-center items-center">
            <Loader />
          </div>
        )}
        {text}
      </button>
    </>
  );
};

export default DeleteButton;
